"use strict";
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/naming-convention */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyzeGraph = void 0;
const lodash_1 = require("lodash");
const object_hash_1 = __importDefault(require("object-hash"));
const data_schema_core_1 = require("@tencent/data-schema-core");
/**
 * 反转流程图并计算每一个 node 的哈希、依赖关系
 */
function analyzeGraph(flow) {
    const tailIds = [];
    const nodeInfoLUT = {};
    const getNodeInfo = (nodeId) => {
        if (!nodeId)
            return null;
        let ans = nodeInfoLUT[nodeId];
        if (!ans) {
            const node = flow.nodes[nodeId];
            if (!node) {
                throw new Error(`flow graph node:${nodeId} not found`);
            }
            // eslint-disable-next-line no-multi-assign
            nodeInfoLUT[nodeId] = ans = {
                node,
                nodeId,
                dependencies: [],
                dependents: [],
                fullHash: '',
                selfHash: (0, object_hash_1.default)([nodeId, node.type, node.next, node.params, node.hookFinish]),
                dependencyHash: '',
            };
        }
        return ans;
    };
    (0, lodash_1.forEach)(flow.nodes, (node, nodeId) => {
        const nodeInfo = getNodeInfo(nodeId);
        const nextIds = (0, lodash_1.values)(node.next);
        (0, lodash_1.forEach)(nextIds, (value) => {
            var _a;
            if (!value)
                return;
            nodeInfo === null || nodeInfo === void 0 ? void 0 : nodeInfo.dependencies.push(value);
            (_a = getNodeInfo(value)) === null || _a === void 0 ? void 0 : _a.dependents.push(nodeId);
        });
        if (!nextIds.length)
            tailIds.push(nodeId);
    });
    (0, lodash_1.forEach)(nodeInfoLUT, (nodeInfo) => {
        nodeInfo.dependencies = (0, lodash_1.uniq)(nodeInfo.dependencies).sort();
        nodeInfo.dependents = (0, lodash_1.uniq)(nodeInfo.dependents).sort();
        (0, data_schema_core_1.defineLazyGetter)(nodeInfo, 'dependencyHash', () => {
            if (nodeInfo.nodeId === 'start') {
                return (0, object_hash_1.default)([flow.params, flow.stateSchema]);
            }
            const visited = new Set([nodeInfo.nodeId]);
            const queue = [...nodeInfo.dependencies];
            const result = [];
            while (queue.length) {
                const parentId = queue.shift();
                if (!parentId || visited.has(parentId))
                    continue;
                visited.add(parentId);
                const parent = getNodeInfo(parentId);
                if (parent) {
                    result.push(parent.selfHash);
                    queue.push(...parent.dependencies);
                }
            }
            return (0, object_hash_1.default)(result);
        });
        (0, data_schema_core_1.defineLazyGetter)(nodeInfo, 'fullHash', () => `${nodeInfo.selfHash}-${nodeInfo.dependencyHash}`);
    });
    getNodeInfo.tailIds = tailIds;
    getNodeInfo.getNodeInfo = getNodeInfo;
    return getNodeInfo;
}
exports.analyzeGraph = analyzeGraph;
//# sourceMappingURL=analyzeGraph.js.map